import React, { createRef } from 'react';
import PropTypes from 'prop-types';
import { Button, UncontrolledTooltip } from 'reactstrap';

const InfoTooltip = ({ children, placement = 'top', ...props }) => {
  const ref = createRef();
  return (
    <>
      <i className="fa fa-info-circle" aria-hidden="true" ref={ref} {...props} />
      <UncontrolledTooltip placement={placement} target={ref}>
        {children}
      </UncontrolledTooltip>
    </>
  );
};

InfoTooltip.propTypes = {
  ...Button.propTypes,
  children: PropTypes.node,
  tooltipPlacement: UncontrolledTooltip.propTypes.placement,
};

export { InfoTooltip };
